const giftMessage = (state = "", action) => {
    switch(action.type) {
        case 'giftMessage':
            return action.payload;
        default:
            return state;
    }
}

export default giftMessage;